// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaZ = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M8.41 17v-1.33l4.101-5.698.643-.891c.172-.239.296-.41.435-.607-.378.014-.798.014-1.162.014H8.591v-1.54h7.042v1.456l-4.2 5.81c-.172.235-.375.5-.562.745-.147.193-.285.373-.39.515.364-.014.994-.014 1.652-.014h3.752V17z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaZ;
